var users = [{
        "id": 1,
        "name": "kim seok-jin",
        "username": "kim",
        "img": "https://i.postimg.cc/59HjfPBV/1.jpg",
        "email": "kim@gmail.com",
        "salary": 159999,
        "address": {
            "street": "Kulas Light",
            "suite": "Apt. 556",
            "city": "Gwenborough",
            "zipcode": "92998-3874",
            "geo": {
                "lat": "-37.3159",
                "lng": "81.1496"
            }
        },
        "phone": "019......2",
    },
    {
        "id": 2,
        "name": "son ye jin",
        "img": "https://i.postimg.cc/vBxMwNp2/2.jpg",
        "username": "jin",
        "email": "jin@gmail.com",
        "salary": 299999,
        "address": {
            "street": "Victor Plains",
            "suite": "Suite 879",
            "city": "Wisokyburgh",
            "zipcode": "90566-7771",
            "geo": {
                "lat": "-43.9509",
                "lng": "-34.4618"
            }
        },
        "phone": "062....4",
    },
    {
        "id": 3,
        "name": "dany lopez",
        "img": "https://i.postimg.cc/P5VBfMbg/3.jpg",
        "username": "dany",
        "email": "dany@gmail.com",
        "salary": 19999,
        "address": {
            "street": "Douglas Extension",
            "suite": "Suite 847",
            "city": "McKenziehaven",
            "zipcode": "59590-4157",
            "geo": {
                "lat": "-68.6102",
                "lng": "-47.0653"
            }
        },
        "phone": "993...0",
    },
    {
        "id": 4,
        "name": "Mark Luiz",
        "img": "https://i.postimg.cc/vTGPt1L7/4.jpg",
        "username": "Luiz",
        "email": "markluiz@gmail.com",
        "salary": 499999,
        "address": {
            "street": "Hoeger Mall",
            "suite": "Apt. 692",
            "city": "South Elvis",
            "zipcode": "53919-4257",
            "geo": {
                "lat": "29.4572",
                "lng": "-164.2990"
            }
        },
        "phone": "493-170-9623 x156",
       
    },
    {
        "id": 5,
        "name": "Jonathen Smith",
        "img": "https://i.postimg.cc/KjcNg6xJ/5.jpg",
        "username": "Smith",
        "email": "smith@gmail.com",
        "salary": 299999,
        "address": {
            "street": "Skiles Walks",
            "suite": "Suite 351",
            "city": "Roscoeview",
            "zipcode": "33263",
            "geo": {
                "lat": "-31.8129",
                "lng": "62.5342"
            }
        },
        "phone": "(254)954-1289",
        "website": "demarco.info",
        "company": {
            "name": "Keebler LLC",
            "catchPhrase": "User-centric fault-tolerant solution",
            "bs": "revolutionize end-to-end systems"
        }
    },
    {
        "id": 6,
        "name": "Mr. David Ford",
        "img": "https://i.postimg.cc/VNrLzvtF/6.jpg",
        "username": "Leopoldo_Corkery",
        "email": "Karley_Dach@jasper.info",
        "salary": 499999,
        "address": {
            "street": "Norberto Crossing",
            "suite": "Apt. 950",
            "city": "South Christy",
            "zipcode": "23505-1337",
            "geo": {
                "lat": "-71.4197",
                "lng": "71.7478"
            }
        },
        "phone": "1-477-935-8478 x6430",
    },
    {
        "id": 7,
        "name": "Handerson",
        "img": "https://i.postimg.cc/52ZWq3Hw/7.png",
        "username": "Handerson",
        "email": "handerson@gmail.com",
        "salary": 599999,
        "address": {
            "street": "Rex Trail",
            "suite": "Suite 280",
            "city": "Howemouth",
            "zipcode": "58804-1099",
            "geo": {
                "lat": "24.8918",
                "lng": "21.8984"
            }
        },
        "phone": "210.067.6132",
    },
    {
        "id": 8,
        "name": "Ven Boitler",
        "img": "https://i.postimg.cc/02YVH0HY/8.jpg",
        "username": "Ven",
        "salary": 999999,
        "email": "venboitler@gmail.com",
        "address": {
            "street": "Ellsworth Summit",
            "suite": "Suite 729",
            "city": "Aliyaview",
            "zipcode": "45169",
            "geo": {
                "lat": "-14.3990",
                "lng": "-120.7677"
            }
        },
        "phone": "586.493.6943 x140",
    },
    {
        "id": 9,
        "name": "Smith Josef",
        "img": "https://i.postimg.cc/Fz2wgFzh/9.jpg",
        "username": "Smith",
        "salary": 699999,
        "email": "smith@gmail.com",
        "address": {
            "street": "Dayna Park",
            "suite": "Suite 449",
            "city": "Bartholomebury",
            "zipcode": "76495-3109",
            "geo": {
                "lat": "24.6463",
                "lng": "-168.8889"
            }
        },
        "phone": "(775)976-6794 x41206",
    },
    {
        "id": 10,
        "name": "Jack Morlen",
        "img": "https://i.postimg.cc/FRz6MkJ9/10.jpg",
        "username": "Morlen",
        "email": "jackmorlen@gmail.com",
        "salary": "99999",
        "address": {
            "street": "Kattie Turnpike",
            "suite": "Suite 198",
            "city": "Lebsackbury",
            "zipcode": "31428-2261",
            "geo": {
                "lat": "-38.2386",
                "lng": "57.2232"
            }
        },
        "phone": "024-648-3804",
    },
    {
        "id": 11,
        "name": "Komen",
        "img": "https://i.postimg.cc/7Lt4Jk3Z/11.jpg",
        "username": "Komen",
        "email": "komen@gmail.com",
        "salary": 499999,
        "address": {
            "street": "Kattie Turnpike",
            "suite": "Suite 198",
            "city": "Lebsackbury",
            "zipcode": "31428-2261",
            "geo": {
                "lat": "-38.2386",
                "lng": "57.2232"
            }
        },
        "phone": "014-648-3804",
    },
    {
        "id": 12,
        "name": "Rockiey",
        "img": "https://i.postimg.cc/3R0syDrt/12.jpg",
        "username": "Rockiey",
        "email": "rockiey@gmail.com",
        "salary": "650000",
        "address": {
            "street": "Kattie Turnpike",
            "suite": "Suite 198",
            "city": "Lebsackbury",
            "zipcode": "31428-2261",
            "geo": {
                "lat": "-38.2386",
                "lng": "57.2232"
            }
        },
        "phone": "014-648-3804",
        
    },
    {
        "id": 13,
        "name": "Danial",
        "img": "https://i.postimg.cc/MK99SpqH/13.jpg",
        "username": "Danial",
        "email": "danial@gmail.com",
        "salary": 750000,
        "address": {
            "street": "Kattie Turnpike",
            "suite": "Suite 198",
            "city": "Lebsackbury",
            "zipcode": "31428-2261",
            "geo": {
                "lat": "-38.2386",
                "lng": "57.2232"
            }
        },
        "phone": "014-648-3804",
    },
    {
        "id": 14,
        "name": "Shane Umit",
        "img": "https://i.postimg.cc/RZ3Lx1gp/14.jpg",
        "username": "Shane",
        "email": "shane@gmail.com",
        "salary": 240000,
        "address": {
            "street": "Kattie Turnpike",
            "suite": "Suite 198",
            "city": "Lebsackbury",
            "zipcode": "31428-2261",
            "geo": {
                "lat": "-38.2386",
                "lng": "57.2232"
            }
        },
        "phone": "014-648-3804",
    },
    {
        "id": 15,
        "name": "Mandela Flora",
        "img": "https://i.postimg.cc/wjJRkwfz/15.jpg",
        "username": "Mandela",
        "email": "mandela@gmail.com",
        "salary": 145000,
        "address": {
            "street": "Kattie Turnpike",
            "suite": "Suite 198",
            "city": "Lebsackbury",
            "zipcode": "31428-2261",
            "geo": {
                "lat": "-38.2386",
                "lng": "57.2232"
            }
        },
        "phone": "014-648-3804",
    }

]
export default users;